import { styled } from '@linaria/react';
import { layout, semantic } from '../../theme/tokens';

export const Shell = styled.div`
  display: flex;
  flex-direction: column;
  --layout-viewport-height: calc(100vh - var(--announcement-banner-height, 0px));
  min-height: var(--layout-viewport-height);
  padding-top: var(--announcement-banner-height, 0px);
  background: ${semantic.bg.canvas};
  --sticky-footer-offset-bottom: ${layout.mobileNavHeight};
  --shell-mobile-nav-height: ${layout.mobileNavHeight};

  @media (min-width: ${layout.desktopBreakpoint}) {
    --sticky-footer-offset-bottom: 0px;
    --shell-mobile-nav-height: 0px;
  }
`;

export const Body = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  min-height: 0;
`;

export const ContentArea = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  padding-bottom: calc(${layout.mobileNavHeight} + var(--page-sticky-bar-height, 0px));

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding-bottom: var(--page-sticky-bar-height, 0px);
  }
`;

export const Main = styled.main`
  flex: 1;
  min-width: 0;
  overflow-x: clip;
`;
